import isFQDN from 'validator/lib/isFQDN'

/**
 * Validates any value as a fully qualified domain
 *
 * Return Validation Result:
 * {
 *   valid: Boolean,
 *   error: String | null
 * }
 * @param {*} valueToValidate Value to determine if is fully qualified domain
 * @returns {object} Validation Result
 */
const fullyQualifiedDomain = (valueToValidate) => {
  const validResponse = {
    errors: [],
    valid: true,
  }

  if (!valueToValidate) {
    return validResponse
  }

  if (!isFQDN(valueToValidate)) {
    return {
      errors: ['Must be a domain (e.g. owner.com)'],
      valid: false,
    }
  }

  return validResponse
}

export { fullyQualifiedDomain }
